import { createAction } from "typesafe-actions";
import { Insurance } from "@app/itineraries/types/interfaces";

const LOAD_INSURANCES = "[Insurances] Load Insurances";

export const LoadInsurances = createAction(
  LOAD_INSURANCES,
  (insurances: Insurance[]) => insurances
)<Insurance[]>();
